import { useParams, Link } from 'react-router-dom';

const Assignment = ({data}) => {
  const { key } = useParams();
  const assnData = data[key];

  if (!assnData) {
    return <></>;
  }

  /////////////////////////
  // render
  /////////////////////////
  return (
    <div className="flex flex-col mt-6 mx-8 space-y-6 md:tracking-wide text-linen">

      <div className="flex flex-col space-y-4 p-3 rounded bg-cod-gray-mid">
        <div className="flex flex-row justify-between">
          <div className="flex flex-row space-x-3">
            <Link
             to=".."
             className="px-2 py-2 text-2xl w-min flex items-center
             border border-white rounded
             hover:bg-utrgv-blue hover:text-white cursor-pointer" >&lt;</Link>
            <div className="my-auto">
              <div className="text-xl">{assnData.title}</div>
              <div className="break-all"><a href={assnData.url}>{assnData.url}</a></div>
              <div className="mt-1">{assnData.due}</div>
            </div>
          </div>
        </div>

        <div className="p-3 bg-cod-gray">
          {assnData.penalty
          ?
          <>
            <div>Total: {assnData.total} / {assnData.max_total}</div>
            <div>Penalty applied, max allowable score is {parseFloat(assnData.penalty).toFixed(2) * 100}%</div>
            {assnData.penalty_comment && 
              <div>Penalty comment: <em>{assnData.penalty_comment}</em></div>}
            <div>Final score: {parseFloat(assnData.final).toFixed(2) * 100}%</div>
          </>
          :
          <>
            <div>Total: {assnData.total} / {assnData.max_total} ({parseFloat(assnData.final).toFixed(2) * 100}%)</div>
          </>
          } 
        </div>

        {assnData.sections.map(({title, tasks, comment}) =>
        <>
          <div className="p-3 bg-cod-gray">
            <div>Section: {title}</div>
            {comment && <div className="my-1">Comment on scoring: {comment}</div>}

            <div className="grid grid-cols-2 border-t">
              {tasks.map(({max_score, score, task}) =>
              <>
                <div className="px-2 pt-2 ">{task}</div>
                <div className="px-2 pt-2 ">{score} / {max_score}</div>
              </>
              )}
            </div>

          </div>
        </>
        )}
      </div>
    </div>
  );
};

export default Assignment;
